<template>
  <div>
    <el-form class="balance-filter" :model="query" label-width="88px" @keyup.enter.native="search">
      <el-form-item label="期初年度">
        <el-select v-model="query.financePeriodId" size="small" style="width:100%" @change="search">
          <el-option v-for="item in years" :key="item.financePeriodId" :label="item.year" :value="item.financePeriodId" />
        </el-select>
      </el-form-item>
      <el-form-item label="客户编码">
        <el-input v-model="query.partnerCode" size="small" clearable />
      </el-form-item>
      <el-form-item label="客户名称">
        <el-input v-model="query.partnerName" size="small" clearable />
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('finance:customerBalance:list')" type="primary" size="small" @click="search">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="balance-scope-tip">期初列按所选年度；业务列为历史累计；当前未结余额与今日账龄一致。</div>
    <el-table :data="list" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="partnerCode" label="客户编码" width="130" />
      <el-table-column prop="partnerName" label="客户名称" min-width="320">
        <template slot-scope="s"><div class="partner-name-cell"><span class="partner-name">{{ s.row.partnerName }}</span><el-tooltip v-if="Number(s.row.abnormalInvoiceCount) > 0" content="存在无明细或金额不一致的已审销项发票，请核查原单" placement="top"><el-tag type="warning" size="mini">异常发票 {{ s.row.abnormalInvoiceCount }}</el-tag></el-tooltip><el-tooltip v-if="Number(s.row.duplicateReturnCount) > 0" content="同一退货关联的销售退货结算和销项红字发票均已生成凭证，可能重复冲减，请核查凭证" placement="top"><el-tag type="danger" size="mini">退货重复记账 {{ s.row.duplicateReturnCount }}</el-tag></el-tooltip></div></template>
      </el-table-column>
      <el-table-column prop="openingAmount" label="期初应收" width="110" align="right"><template slot-scope="s">{{ money(s.row.openingAmount) }}</template></el-table-column>
      <el-table-column prop="openingSettledAmount" label="期初已收" width="110" align="right"><template slot-scope="s">{{ money(s.row.openingSettledAmount) }}</template></el-table-column>
      <el-table-column prop="billAmount" label="累计应收" width="110" align="right"><template slot-scope="s">{{ money(s.row.billAmount) }}</template></el-table-column>
      <el-table-column prop="invoicedAmount" label="累计已开票" width="120" align="right"><template slot-scope="s">{{ money(s.row.invoicedAmount) }}</template></el-table-column>
      <el-table-column prop="settledAmount" label="业务结清/冲减" width="135" align="right"><template slot-scope="s">{{ money(s.row.settledAmount) }}</template></el-table-column>
      <el-table-column prop="balanceAmount" label="当前未结应收" width="130" align="right"><template slot-scope="s">{{ money(s.row.balanceAmount) }}</template></el-table-column>
      <el-table-column prop="redCreditAmount" label="红字超收待退" width="130" align="right"><template slot-scope="s">{{ money(s.row.redCreditAmount) }}</template></el-table-column>
      <el-table-column prop="returnSettleCreditAmount" label="退货结算待退款" width="145" align="right"><template slot-scope="s">{{ money(s.row.returnSettleCreditAmount) }}</template></el-table-column>
    </el-table>
    <el-pagination style="margin-top:12px;text-align:right" :current-page="pageIndex" :page-size="pageSize" :page-sizes="[20,50,100]" :total="total" layout="total, sizes, prev, pager, next" @size-change="sizeChange" @current-change="pageChange" />
  </div>
</template>

<script>
import request from '../../api/request'
import auth from './financeAuth'

export default {
  mixins: [auth],
  data() { return { query: { financePeriodId: '', partnerCode: '', partnerName: '' }, years: [], list: [], pageIndex: 1, pageSize: 20, total: 0 } },
  created() { this.loadYears() },
  methods: {
    indexMethod(index) { return (this.pageIndex - 1) * this.pageSize + index + 1 },
    loadYears() {
      request.get('/finance/partnerBalance/years').then(res => {
        this.years = res.data || []
        if (!this.query.financePeriodId && this.years.length) this.query.financePeriodId = this.years[0].financePeriodId
        this.load()
      }).catch(() => { this.load() })
    },
    search() { this.pageIndex = 1; this.load() },
    sizeChange(v) { this.pageSize = v; this.pageIndex = 1; this.load() },
    pageChange(v) { this.pageIndex = v; this.load() },
    load() {
      this.loading = true
      request.get('/finance/partnerBalance/list', { params: { kind: 'customer', financePeriodId: this.query.financePeriodId, partnerCode: this.query.partnerCode, partnerName: this.query.partnerName, currentPage: this.pageIndex, pageSize: this.pageSize } })
        .then(res => { const data = res.data || {}; this.list = data.list || []; this.total = data.totalCount || 0 })
        .finally(() => { this.loading = false })
    }
  }
}
</script>

<style scoped>
.balance-filter { display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 8px 16px; margin-bottom: 8px; }
::v-deep .balance-filter .el-form-item { display: flex; min-width: 0; margin: 0; }
::v-deep .balance-filter .el-form-item__label { flex: 0 0 88px; padding-right: 8px; }
::v-deep .balance-filter .el-form-item__content { flex: 1; min-width: 0; margin-left: 0 !important; }
::v-deep .balance-filter .el-form-item__content > .el-input { width: 100%; }
::v-deep .balance-filter .el-form-item:last-child { padding-left: 88px; }
.balance-scope-tip { color: #909399; font-size: 12px; line-height: 1.5; margin: 0 0 12px; }
.partner-name-cell { display: flex; align-items: center; gap: 8px; white-space: nowrap; overflow: hidden; }
.partner-name { overflow: hidden; text-overflow: ellipsis; }
.partner-name-cell .el-tag { flex-shrink: 0; }
</style>
